import ChangeSignInByOTPComponent from './ChangeSignInByOTPContainer';

export  default ChangeSignInByOTPComponent ;